import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductCompareService } from '../../../../features/admin/product/services/compare-product.service';

@Component({
    selector: 'app-selected-compare-product',
    standalone: false,
    templateUrl: './selected-compare-product.component.html',
    styleUrl: './selected-compare-product.component.scss',
})
export class SelectedCompareProductComponent implements OnInit, OnDestroy {
    protected selectedIds: number[] = [];
    private sub!: Subscription;

    constructor(
        private productCompareService: ProductCompareService,
        private router: Router,
    ) {}
    ngOnInit(): void {
        this.sub = this.productCompareService.selectedIds$.subscribe({
            next: (ids) => {
                this.selectedIds = ids;
            },
        });
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    protected onCancel(): void {
        this.productCompareService.clear();
    }

    protected onCompare(): void {
        if (!this.selectedIds.length) {
            return;
        }

        this.router.navigate(['/products/compare-product'], {
            queryParams: {
                compareProductIds: this.selectedIds,
            },
        });
    }
}
